import React, {forwardRef} from 'react';
import {getElementAttributes} from 'helpers';
import css from './common.module.scss';

export const NoWrap = forwardRef((props, ref) =>
  <span {...getElementAttributes(props)} className={css('no-wrap', props)} ref={ref} />
);
